/**
 * Export colors - single source of truth for PDF, DOCX, and Excel exports
 * Each color has hex (for DOCX), rgb (for PDF), and argb (for Excel) formats
 *
 * Note: These colors correspond to CSS variables defined in @consigli/facade/colors.css
 * Exports require raw values (can't use CSS variables), so we duplicate them here.
 */
export const EXPORT_COLORS = {
    // Primary colors
    headingBlue: {
        hex: '2F5496',
        rgb: [47, 84, 150],
        argb: 'FF2F5496',
    },
    brand: {
        hex: '475569',
        rgb: [71, 85, 105],
        argb: 'FF475569',
    },
    brandHover: {
        hex: '64748b',
        rgb: [100, 116, 139],
        argb: 'FF64748b',
    },
    darkBlue: {
        hex: '273640',
        rgb: [39, 54, 64],
        argb: 'FF273640',
    },
    // Neutral colors
    headerGrey: {
        hex: 'D7DEE2',
        rgb: [215, 222, 226],
        argb: 'FFD7DEE2',
    },
    lightGrey: {
        hex: 'E4EAF4',
        rgb: [228, 234, 244],
        argb: 'FFE4EAF4',
    },
    textGrey: {
        hex: '646464',
        rgb: [100, 100, 100],
        argb: 'FF646464',
    },
    black: {
        hex: '000000',
        rgb: [0, 0, 0],
        argb: 'FF000000',
    },
    white: {
        hex: 'FFFFFF',
        rgb: [255, 255, 255],
        argb: 'FFFFFFFF',
    },
};
